type PartialLocationType = Pick<Location, 'pathname' | 'hash' | 'search'>;

export const getMobileRedirectPath = (
	location: PartialLocationType,
	basePath: string,
	redirectTo: string
): string => {
	const { pathname, search, hash } = location;
	const remainingPath = pathname.replace(basePath, '');
	return `${redirectTo}${remainingPath}${search}${hash}`;
};
